module.exports = __webpack_public_path__ + "assets/4335360b48dc8051e147b1c41fb57dbc.png";